// Variant wrapper and ReCharge price handler
(function() {
  if (typeof jQuery === 'undefined') {
    return;
  }

  jQuery(document).ready(function() {
    jQuery(".cus-var-wraper").each(function() {
      var zeroQuantityDivs = jQuery(this)
        .find(".variant-container[data-quantity=' 0']").detach();
      jQuery(this).append(zeroQuantityDivs);
      setTimeout(function() {
        jQuery('.cus-var-wraper .variant-container:eq(0) .color-circle').trigger('click');
      }, 200);
    });

    // Recharge app Price Fix on PDP
    // Function to normalize price formatting (remove spaces between $ and number)
    function normalizePrice(priceText) {
      if (!priceText) return priceText;
      return priceText.replace(/\$\s+/g, '$').replace(/\s+\$/g, '$').trim();
    }

    // Function to fetch and update price
    function updatePrice() {
      let new_price = jQuery('select.select__select option:selected').attr('data-variant-price');
      if (new_price) {
        new_price = normalizePrice(new_price.trim());
        new_price = new_price.replace(/\$\s*/, '$');
        jQuery('.rc_widget__price--onetime').text(new_price);

        let price_value = parseFloat(new_price.replace('$', '').replace(',', ''));
        let discounted_price = price_value * 0.85; // Apply 15% discount
        let formatted_discounted_price = '$' + discounted_price.toFixed(2);
        jQuery('.rc_widget__price--subsave').text(formatted_discounted_price);
      }
    }

    // Function to run interval for 5 seconds
    function runPriceUpdate() {
      updatePrice();
      let priceInterval = setInterval(updatePrice, 100);
      setTimeout(function() {
        clearInterval(priceInterval);
      }, 6000); 
    }

    // Run on page load
    runPriceUpdate();

    // Run on dropdown change
    jQuery('select.select__select').on('change', function() {
      runPriceUpdate();
    });
  });
})();

